import { store } from "./store"

export default {
    processGames(games) {
        if (!games || games.length === 0) {
            console.log("no games to process")
            return 0
        }
        let stats = store.state.gameStats
        stats.games = games.length;
        for (let game of games) {
            //TODO player stats for every season
            //TODO player stats in general

            if (!Object.keys(stats.seasons).includes(game.season.toString())) {
                //stats for every season
                stats.seasons[game.season] = {
                    beers: 0,
                    games: 0,
                    rounds: 0,
                    shortGames: 0
                }
            }
            if (game.state === 3) {
                let rounds
                if (game.team1_score === 1 || game.team2_score === 1) rounds = 3
                else {
                    rounds = 2
                }
                stats.rounds += rounds
                stats.shortGames += rounds === 2 ? 1 : 0
                stats.seasons[game.season].rounds += rounds
                stats.seasons[game.season].shortGames += rounds === 2 ? 1 : 0
                stats.seasons[game.season].games++
            }
        }
        stats.beers = stats.rounds * 16
        let startingSeason = 2
        let newSeasons = {}
        for (let season in stats.seasons) {
            stats.seasons[season].beers = stats.seasons[season].rounds * 16
            stats.seasons[season].id = season
            newSeasons[startingSeason.toString()] = stats.seasons[season]
            startingSeason++
        }        
        stats.seasons = newSeasons
        store.commit("setCurrentSeason", Math.max(...Object.keys(stats.seasons).map(item => +item)))
        store.commit("setGameStats", stats)
    },
    addStatsToPlayers(players, stats, seasons) {
        let statName = ["games", "wins", "loses", "winPercent", "rounds", "roundsWon", "roundsLost", 
                        "roundsPercent", "twoZero", "twoZeroPercentWins", "twoZeroPercentAll", "twoOne", 
                        "twoOnePercentWins", "twoOnePercentAll", "zeroTwo", "zeroTwoPercentWins", "zeroTwoPercentAll", 
                        "oneTwo", "oneTwoPercentWins", "oneTwoPercentAll", "winOnTwoRoundsPercent", "winOnThreeRoundsPercent"]
        let seasonsCount = stats[Object.keys(stats)[0]].length - 1
        for (let player of players) {
            if (stats[player.name]) {
                player.seasons = {}
                Object.keys(seasons).map(item => player.seasons[item] = {})
                for(let [i, name] of statName.entries()){
                    player[name] = stats[player.name][0][i]
                    for(let key of Object.keys(seasons)){
                        player.seasons[key][name] = stats[player.name][seasonsCount - (+key - 2)][i]
                    }
                }
            } else {
                player.seasons = {}
                Object.keys(seasons).map(item => player.seasons[item] = {})
                for(let name of statName){
                    player[name] = 0
                    for(let key of Object.keys(seasons)){
                        player.seasons[key][name] = 0
                    }
                }
            }
        }
        store.commit("setPlayers", players)
    },
    calculateTeamElo(team){
        return Math.floor((team.reduce((acc, b) => acc + b.elo, 0)) / team.length)
    },
    calculateEloChange(elo1, elo2, win){
        let res = 1 / (1 + 10 ** ((elo2 - elo1) / 400))
        return 32 * ((win ? 1: 0) - res)
    },
    eloDecay(players, season){
        const seasons = store.state.gameStats.seasons
        const index = Object.values(seasons).findIndex(item => item.id == season)
        const currentSeason = Object.keys(seasons)[index]
        players.map(player => {
            player.seasons[currentSeason].score = player.seasonElo ? player.elo: 0
            player.seasons[currentSeason].season_best = player.seasonElo
            player.seasons[currentSeason].season_worst = player.seasonWorst != Infinity ? player.seasonWorst: 0
            player.elo = Math.floor((player.elo - 1500) / 2 + 1500)
            player.seasonElo = 0
            player.seasonWorst = Infinity
        })
    },
    calculateElos(games, players){
        players.map(player => {
            player.elo = 1500
            player.seasonElo = 0
            player.seasonWorst = Infinity
        })
        let season = null
        games = games.sort((a,b) => {
             return new Date(a.date).getTime() - new Date(b.date).getTime()
        })       

        for(let game of games){            
            if(game.state != 3 || game.players.length != 6 || (game.team1_score + game.team2_score <! 2 && game.team1_score + game.team2_score >! 3)) {
                continue
            }            
            if(season == null) season = game.season
            if(game.season != season){
                this.eloDecay(players, season)
                season = game.season
            }
            let team1 = game.players.filter(player => player.team == 1)
            let team2 = game.players.filter(player => player.team == 2)
            if(team1.length != 3 || team2.length != 3) continue
            team1 = team1.map(item => {
                return players.find(player => player.id == item.id)
            })
            team2 = team2.map(item => {
                return players.find(player => player.id == item.id)
            })            
            for(let player of team1){
                game.players.find(item => item.name == player.name ).elo = player.elo
            }
            for(let player of team2){
                game.players.find(item => item.name == player.name ).elo = player.elo
            }
            let preElo1 = this.calculateTeamElo(team1)
            let preElo2 = this.calculateTeamElo(team2)
            let eloChange = (game.team1_score * this.calculateEloChange(preElo1, preElo2, true)
                        + game.team2_score * this.calculateEloChange(preElo1, preElo2, false))
            team1.map(player => {
                player.elo = Math.floor(player.elo + eloChange)
                if(player.elo > player.seasonElo) player.seasonElo = player.elo
                if(player.elo < player.seasonWorst) player.seasonWorst = player.elo
            })
            team2.map(player => {
                player.elo = Math.floor(player.elo - eloChange)
                if(player.elo > player.seasonElo) player.seasonElo = player.elo
                if(player.elo < player.seasonWorst) player.seasonWorst = player.elo
            })
            if(game.team1_score > game.team2_score && eloChange < 0){
                game.elo = Math.floor(eloChange)
            }else if(game.team2_score > game.team1_score && eloChange > 0){
                game.elo = Math.floor(eloChange)
            }else {
                game.elo = Math.floor(Math.abs(eloChange))
            }
        }
        const seasons = store.state.gameStats.seasons
        const index = Object.values(seasons).findIndex(item => item.id == season)
        if(index != Object.values(seasons).length - 1){
            this.eloDecay(players, season)
        }
        players.map(player => {
            let lastSeason = Object.keys(player.seasons).at(-1)
            player.seasons[lastSeason].score = player.score
            player.seasons[lastSeason].season_best = player.season_best
            player.seasons[lastSeason].season_worst = player.seasonWorst
            player.season_best = 0
            player.season_worst = Infinity
            for(let key in player.seasons){
                if(player.season_best < player.seasons[key].season_best) player.season_best = player.seasons[key].season_best
                if(player.season_worst > player.seasons[key].season_worst && 
                    player.seasons[key].season_worst != 0) player.season_worst = player.seasons[key].season_worst                
            }
            if(player.season_worst == Infinity) player.season_worst = 0
            let startingSeason = 2
            let newSeasons = {}
            for (let key in player.seasons) {
                newSeasons[startingSeason.toString()] = player.seasons[key]
                startingSeason++
            }        
            player.seasons = newSeasons
        })
        store.commit("setPlayers", players)
    },
}

